import React from 'react';
import ShareRewindSlideBase from './ShareRewindSlideBase';
import CustomCruiseIcon from '../CustomCruiseIcon';

interface ShareRewindClosingSlideProps {
  year: number;
}

const ShareRewindClosingSlide = React.forwardRef<HTMLDivElement, ShareRewindClosingSlideProps>(
  ({ year }, ref) => {
    return (
      <ShareRewindSlideBase ref={ref} year={year}>
        <div className="flex flex-col items-center justify-center h-full text-center">
          <div className="mb-8">
            <CustomCruiseIcon size={120} className="text-white" />
          </div>
          <div className="text-7xl font-bold text-white leading-none mb-6">
            Cruising Along
          </div>
          <div className="text-6xl text-white/90 font-medium mb-8">
            Track Your Cruise Adventures
          </div>
          <div 
            style={{ 
              fontSize: '2.5rem',
              color: '#fbbf24',
              backgroundColor: 'rgba(255, 255, 255, 0.15)',
              padding: '1rem 2rem',
              borderRadius: '9999px',
              textAlign: 'center',
              display: 'inline-block',
              width: 'fit-content',
              margin: '0 auto',
              whiteSpace: 'nowrap',
              lineHeight: '1',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.2)'
            }}
          >
            keep.cruisingalong.com
          </div>
          <div className="text-5xl text-white/80 font-medium mt-8">
            Rewind {year}
          </div>
        </div>
      </ShareRewindSlideBase>
    );
  }
);

ShareRewindClosingSlide.displayName = 'ShareRewindClosingSlide';

export default ShareRewindClosingSlide;

